import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.company.data');
import { ElementRef, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-company-data',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/build/src/app/page.company.data/view.scss */
:host {
  display: block;
  height: 100%;
}

.product-editor-shell {
  min-height: 180px;
}

.product-editor-shell .ck-editor__editable {
  min-height: 150px;
  font-size: 13px;
  line-height: 1.7;
}

.product-editor-shell .ck-content img {
  max-width: 100%;
}`],
})
export class PageCompanyDataComponent implements OnInit, OnDestroy {
    constructor(@Inject( Service) public service: Service,@Inject( ElementRef)  private host: ElementRef) { }

    public company: any = null;
    public menu: string = 'overview';
    public loading: boolean = true;
    public noCompany: boolean = false;
    public saving: boolean = false;
    public uploading: any = {};
    public logoTimestamp: number = Date.now();

    private productEditorCounter: number = 0;
    private productEditorSyncTimer: any = null;
    private productIntroEditor: any = null;
    private productEditors: any = {};
    private productEditorTools: any = null;
    private productEditorToolbar: string[] = 'heading | fontSize | bold italic strikethrough underline | blockQuote code | bulletedList numberedList | outdent indent | uploadImage insertTable link codeBlock horizontalLine | specialCharacters'.split(' ');

    public menuItems = [
        { key: 'overview', label: '개요' },
        { key: 'intro', label: '기업소개' },
        { key: 'product', label: '서비스/제품' },
        { key: 'financial', label: '재무상태표' },
        { key: 'shareholder', label: '주주명부' },
        { key: 'patent', label: '특허현황' },
        { key: 'workforce', label: '인력현황' },
        { key: 'support', label: '지원사업현황' },
        { key: 'business', label: '사업현황' },
        { key: 'tech', label: '기술개발현황' },
        { key: 'overseas', label: '해외진출현황' }
    ];

    public async ngOnInit() {
        await this.service.init();
        const segment = WizRoute.segment;
        if (segment.menu) this.menu = segment.menu;
        await this.loadCompany();
    }

    public ngOnDestroy() {
        this.destroyProductEditors(false);
    }

    public async loadCompany() {
        this.loading = true;
        await this.service.render();
        const { code, data } = await wiz.call("load_company");
        if (code === 200 && data.company) {
            this.destroyProductEditors(false);
            this.company = this.normalizeCompany(data.company);
            this.noCompany = false;
        } else {
            this.noCompany = true;
        }
        this.loading = false;
        await this.service.render();
        this.scheduleProductEditors();
    }

    public async setMenu(key: string) {
        if (this.menu === 'product' && key !== 'product') {
            this.destroyProductEditors(true);
        }
        this.menu = key;
        this.service.href(`/company-data/${key}`);
        await this.service.render();
        this.scheduleProductEditors();
    }

    public isActive(key: string) {
        return this.menu === key;
    }

    public normalizeCompany(company: any) {
        if (!company.extra || typeof company.extra !== 'object' || Array.isArray(company.extra)) {
            company.extra = {};
        }
        if (!Array.isArray(company.extra.products)) {
            company.extra.products = [];
        }
        company.extra.products.forEach((item: any) => this.normalizeProduct(item));
        if (!company.extra.product_intro) {
            company.extra.product_intro = '';
        }
        if (!Array.isArray(company.extra.contacts)) {
            company.extra.contacts = [];
        }
        if (!company.extra.file_history || typeof company.extra.file_history !== 'object') {
            company.extra.file_history = {};
        }
        if (!Array.isArray(company.extra.file_history.ir_file)) {
            company.extra.file_history.ir_file = [];
        }
        if (!Array.isArray(company.extra.file_history.business_license)) {
            company.extra.file_history.business_license = [];
        }
        if (!company.extra.intro) company.extra.intro = '';
        return company;
    }

    public normalizeProduct(item: any) {
        if (!item || typeof item !== 'object') return item;
        if (!item._editor_key) {
            this.productEditorCounter += 1;
            item._editor_key = `product-editor-${Date.now()}-${this.productEditorCounter}`;
        }
        if (!item.description) item.description = '';
        return item;
    }

    public activeClass(key: string) {
        if (this.isActive(key)) {
            return "group flex gap-x-3 rounded-md bg-zinc-50 py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-blue-600";
        }
        return "group flex gap-x-3 rounded-md py-2 pl-2 pr-3 text-sm font-semibold leading-6 text-zinc-700 hover:bg-zinc-50 hover:text-blue-600 cursor-pointer";
    }

    public profilePayload(section: string) {
        this.syncProductEditorData();

        if (section === 'intro') {
            return {
                extra: {
                    intro: this.company.extra?.intro || ''
                }
            };
        }

        if (section === 'product') {
            return {
                product: this.company.product || '',
                extra: {
                    product_intro: this.company.extra?.product_intro || '',
                    products: this.company.extra?.products || []
                }
            };
        }

        return {
            company_name: this.company.company_name || '',
            logo_image: this.company.logo_image || '',
            product: this.company.product || '',
            description: this.company.description || '',
            ceo: this.company.ceo || '',
            ceo_phone: this.company.ceo_phone || '',
            extra: {
                location_short: this.company.extra?.location_short || '',
                founded: this.company.extra?.founded || '',
                employees: this.company.extra?.employees || '',
                web: this.company.extra?.web || '',
                business_area: this.company.extra?.business_area || '',
                contacts: this.company.extra?.contacts || []
            }
        };
    }

    public async saveProfile(section: string = 'overview') {
        if (!this.company?.id || this.saving) return;
        this.saving = true;
        await this.service.render();

        const { code, data } = await wiz.call("save_profile", {
            company_id: this.company.id,
            data: JSON.stringify(this.profilePayload(section))
        });

        this.saving = false;
        if (code === 200 && data.company) {
            this.destroyProductEditors(false);
            this.company = this.normalizeCompany(data.company);
            await this.alert("저장되었습니다.", "success");
        } else {
            await this.alert(data?.message || "저장에 실패했습니다.");
        }
        await this.service.render();
        this.scheduleProductEditors();
    }

    public async uploadDocument(documentType: string) {
        if (!this.company?.id) return;
        const accept = documentType === 'ir_file' ? '.pdf,.ppt,.pptx,.key,.doc,.docx' : '.pdf,image/*';
        const files = await this.service.file.select({ accept });
        if (!files || files.length === 0) return;

        this.uploading[documentType] = true;
        await this.service.loading.show();
        await this.service.render();

        let fd = new FormData();
        fd.append('upload', files[0]);
        fd.append('mode', documentType === 'ir_file' ? 'company_ir_file' : 'company_business_license');

        try {
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            const { code, data } = await wiz.call("upload_document", {
                company_id: this.company.id,
                document_type: documentType,
                url,
                filename: files[0].name || ''
            });
            if (code === 200 && data.company) {
                this.company = this.normalizeCompany(data.company);
                await this.alert("파일이 저장되었습니다.", "success");
            } else {
                await this.alert(data?.message || "파일 저장에 실패했습니다.");
            }
        } catch (e) {
            await this.alert("파일 업로드 중 오류가 발생했습니다.");
        }

        this.uploading[documentType] = false;
        await this.service.loading.hide();
        await this.service.render();
    }

    public async uploadLogo() {
        if (!this.company?.id) return;
        const files = await this.service.file.select({ accept: 'image/*' });
        if (!files || files.length === 0) return;

        this.uploading.logo_image = true;
        await this.service.loading.show();
        await this.service.render();

        let fd = new FormData();
        fd.append('upload', files[0]);
        fd.append('mode', 'company_logo');

        try {
            const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
            const { code, data } = await wiz.call("upload_logo", {
                company_id: this.company.id,
                logo_url: url
            });
            if (code === 200 && data.company) {
                this.company = this.normalizeCompany(data.company);
                this.logoTimestamp = Date.now();
                await this.alert("회사 로고가 저장되었습니다.", "success");
            } else {
                await this.alert(data?.message || "회사 로고 저장에 실패했습니다.");
            }
        } catch (e) {
            await this.alert("회사 로고 업로드 중 오류가 발생했습니다.");
        }

        this.uploading.logo_image = false;
        await this.service.loading.hide();
        await this.service.render();
        this.scheduleProductEditors();
    }

    public businessLicenseUrl() {
        return this.company?.extra?.business_license_file || '';
    }

    public fileHistory(documentType: string) {
        const rows = this.company?.extra?.file_history?.[documentType] || [];
        return [...rows].reverse();
    }

    public async addProduct() {
        this.syncProductEditorData();
        if (!this.company.extra) this.company.extra = {};
        if (!Array.isArray(this.company.extra.products)) this.company.extra.products = [];
        this.company.extra.products.push(this.normalizeProduct({ title: '', link: '', description: '', featured_image: '' }));
        await this.service.render();
        this.scheduleProductEditors();
    }

    public async removeProduct(index: number) {
        const ok = await this.alert("서비스/제품을 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!ok) return;
        this.syncProductEditorData();
        const item = this.company.extra.products[index];
        this.destroyProductEditor(item?._editor_key, false);
        this.company.extra.products.splice(index, 1);
        await this.service.render();
        this.scheduleProductEditors();
    }

    public async uploadProductImage(item: any) {
        const files = await this.service.file.select({ accept: 'image/*' });
        if (!files || files.length === 0) return;
        await this.service.loading.show();
        let fd = new FormData();
        fd.append('upload', files[0]);
        fd.append('mode', 'company_product_image');
        const { url } = await this.service.file.upload('/file/upload', fd, async () => { });
        item.featured_image = url;
        await this.service.loading.hide();
        await this.service.render();
        this.scheduleProductEditors();
    }

    public async removeProductImage(item: any) {
        item.featured_image = '';
        await this.service.render();
    }

    public async addContact() {
        if (!this.company.extra) this.company.extra = {};
        if (!Array.isArray(this.company.extra.contacts)) this.company.extra.contacts = [];
        this.company.extra.contacts.push({ name: '', title: '', phone: '', email: '', invited: false });
        await this.service.render();
        this.scheduleProductEditors();
    }

    public async removeContact(index: number) {
        const ok = await this.alert("담당자를 삭제하시겠습니까?", "error", "취소", "삭제");
        if (!ok) return;
        this.company.extra.contacts.splice(index, 1);
        await this.service.render();
        this.scheduleProductEditors();
    }

    public async inviteContact(index: number) {
        if (!this.company?.id) return;
        const contact = this.company.extra?.contacts?.[index];
        if (!contact) return;
        if (!contact.email || !contact.email.includes('@')) {
            await this.alert("유효한 이메일을 입력해주세요.");
            return;
        }

        const ok = await this.alert(`${contact.email}로 초대를 발송하시겠습니까?`, "info", "취소", "초대하기");
        if (!ok) return;

        this.uploading[`contact_${index}`] = true;
        await this.service.loading.show();
        await this.service.render();

        try {
            const { code, data } = await wiz.call("invite_contact", {
                company_id: this.company.id,
                contact_index: index,
                contact: JSON.stringify(contact),
                contacts: JSON.stringify(this.company.extra.contacts || [])
            });
            if (code === 200 && data.company) {
                this.company = this.normalizeCompany(data.company);
                await this.alert(data.already_exists ? "이미 가입된 사용자입니다." : "초대가 발송되었습니다.", data.already_exists ? "info" : "success");
            } else {
                await this.alert(data?.message || "초대 발송에 실패했습니다.");
            }
        } catch (e) {
            await this.alert("초대 발송 중 오류가 발생했습니다.");
        }

        this.uploading[`contact_${index}`] = false;
        await this.service.loading.hide();
        await this.service.render();
        this.scheduleProductEditors();
    }

    private syncProductEditorData() {
        if (!this.company?.extra?.products) return;
        if (this.productIntroEditor) {
            this.company.extra.product_intro = this.productIntroEditor.data.get();
        }
        for (const key in this.productEditors) {
            const editor = this.productEditors[key];
            const item = this.productByEditorKey(key);
            if (editor && item) {
                item.description = editor.data.get();
            }
        }
    }

    private productByEditorKey(key: string) {
        const products = this.company?.extra?.products || [];
        return products.find((item: any) => item?._editor_key === key);
    }

    private async loadProductEditorTools() {
        if (this.productEditorTools) return this.productEditorTools;
        this.productEditorTools = await import("src/libs/portal/season/ckeditor");
        return this.productEditorTools;
    }

    private scheduleProductEditors() {
        if (this.productEditorSyncTimer) clearTimeout(this.productEditorSyncTimer);
        if (this.menu !== 'product') return;
        this.productEditorSyncTimer = setTimeout(() => {
            this.initProductEditors();
        }, 0);
    }

    private async initProductEditors() {
        if (this.menu !== 'product' || !this.company?.extra?.products) return;
        await this.initProductIntroEditor();
        const elements = this.host?.nativeElement?.querySelectorAll('.product-description-editor[data-product-key]') || [];
        if (!elements.length) return;

        const { ClassicEditor, createCKEditorConfig } = await this.loadProductEditorTools();
        const activeKeys: any = {};
        for (const element of Array.from(elements) as any[]) {
            const key = element.getAttribute('data-product-key');
            const item = this.productByEditorKey(key);
            if (!key || !item) continue;
            activeKeys[key] = true;
            if (this.productEditors[key]) continue;

            const editor = await ClassicEditor.create(element, createCKEditorConfig({ toolbar: this.productEditorToolbar }));
            editor.data.set(item.description || '');
            editor.model.document.on('change:data', () => {
                const target = this.productByEditorKey(key);
                if (target) target.description = editor.data.get();
            });
            this.productEditors[key] = editor;
        }

        for (const key in this.productEditors) {
            if (!activeKeys[key]) this.destroyProductEditor(key, true);
        }
    }

    private async initProductIntroEditor() {
        if (this.productIntroEditor) return;
        const element = this.host?.nativeElement?.querySelector('.product-intro-editor[data-product-intro-editor]');
        if (!element) return;
        const { ClassicEditor, createCKEditorConfig } = await this.loadProductEditorTools();
        const editor = await ClassicEditor.create(element, createCKEditorConfig({ toolbar: this.productEditorToolbar }));
        editor.data.set(this.company?.extra?.product_intro || '');
        editor.model.document.on('change:data', () => {
            if (this.company?.extra) this.company.extra.product_intro = editor.data.get();
        });
        this.productIntroEditor = editor;
    }

    private destroyProductEditor(key: string, readData: boolean = true) {
        if (!key || !this.productEditors[key]) return;
        const editor = this.productEditors[key];
        if (readData) {
            const item = this.productByEditorKey(key);
            if (item) item.description = editor.data.get();
        }
        try { editor.destroy(); } catch (e) { }
        delete this.productEditors[key];
    }

    private destroyProductEditors(readData: boolean = true) {
        if (this.productEditorSyncTimer) {
            clearTimeout(this.productEditorSyncTimer);
            this.productEditorSyncTimer = null;
        }
        if (this.productIntroEditor) {
            if (readData && this.company?.extra) {
                this.company.extra.product_intro = this.productIntroEditor.data.get();
            }
            try { this.productIntroEditor.destroy(); } catch (e) { }
            this.productIntroEditor = null;
        }
        for (const key of Object.keys(this.productEditors)) {
            this.destroyProductEditor(key, readData);
        }
    }

    public timestamp() {
        return new Date().getTime();
    }

    public async alert(message: string, status: string = 'error', cancel: any = false, action: string = '확인') {
        return await this.service.alert.show({
            title: "",
            message,
            cancel,
            actionBtn: status,
            action,
            status
        });
    }
}

export default PageCompanyDataComponent;